// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import AdyenDashboardComponentsController from './adyen_dashboard_components_controller';
application.register('adyen-dashboard-components', AdyenDashboardComponentsController);

import BasketController from "./basket_controller";
application.register("basket", BasketController);

import ConfettiController from './confetti_controller';
application.register('confetti', ConfettiController);

import EvCarouselController from './ev_carousel_controller';
application.register('ev-carousel', EvCarouselController);

import PasskeysLoginController from './passkeys_login_controller';
application.register('passkeys-login', PasskeysLoginController);

import PasskeysRegisterController from './passkeys_register_controller';
application.register('passkeys-register', PasskeysRegisterController);

import PasskeysSupportController from './passkeys_support_controller';
application.register('passkeys-support', PasskeysSupportController);

import PriceEstimatesController from './price_estimates_controller';
application.register('price-estimates', PriceEstimatesController);

import TabsController from './tabs_controller';
application.register('tabs', TabsController);

import YesNoQuestionController from './yes_no_question_controller';
application.register('yes-no-question', YesNoQuestionController);

import DateTimePickerController from "./date_time_picker_controller";
application.register("date-time-picker", DateTimePickerController);

import DateTimePickerDayController from "./date_time_picker_day_controller";
application.register("date-time-picker-day", DateTimePickerDayController);

import PersonalUrlToggleController from './personal_url_toggle_controller';
application.register('personal-url-toggle', PersonalUrlToggleController);

import CompanyTaxFieldsController from './company_tax_fields_controller';
application.register('company-tax-fields', CompanyTaxFieldsController);

import AiWorkSearchToggleController from './ai_work_search_toggle_controller';
application.register('ai-work-search-toggle', AiWorkSearchToggleController);

import AiWorkSearchController from './ai_work_search_controller';
application.register('ai-work-search', AiWorkSearchController);

import AddressAutocompleteController from './address_autocomplete_controller';
application.register('address-autocomplete', AddressAutocompleteController);

import CmpSyncController from './cmp_sync_controller';
application.register('cmp-sync', CmpSyncController);

import MechanicCoverageMapController from './mechanic_coverage_map_controller';
application.register('mechanic-coverage-map', MechanicCoverageMapController);
